
import React ,{ Component } from 'react';
import {Container, Row, Col,Image,Button,Form  } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import "./VolunteerSection.css";
import { withRouter,Link } from "react-router-dom";
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import loader from '../../images/loader.gif';
import MS_logo from '../../images/MahaShakti/MS_logo1.png';
import AD_logo from '../../images/AnnaData/AD_logo1.png';
import BC_logo from '../../images/BC/BC_logo1.png';
import HW_logo from '../../images/HouseWater/HW_logo1.png';
import PTR_logo from '../../images/PoorToRich/PTR_logo1.png';
import YG_logo from '../../images/Yuvagalam/YG_logo1.png';
import YuvaGalamModal from './YuvaGalamModal';
import SuccessPage from    './SuccessPage';
import { scroller } from "react-scroll";

export async function getAPICallData(data,url) {
    
    const response  =    fetch('https://www.mypartydashboard.com/BSA/WebService/'+url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'user_data':''
        },
     body: data
  })

   return response;
}

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };
var interestArr=[];
class VoterSearchEnrollSave extends Component {
    constructor(props) {
        super(props)
        this.mahaShaktiRef = React.createRef();
        this.annaDataRef = React.createRef();
        this.yuvagalamRef = React.createRef();
        this.state = {
            volunteerPhysicalCardId:"",
            volunteerName:"",
            volunteerGender:"",
            volunteerAge:"",
            volunteerMobile:"",
            volunteerOTPNO:"",
            volunteerVoterCard:"",
            volunteerPincode:"",
            volunteerAddress:"",

            volunteerOccupation:"",
            occupationListArr:[],
            occupationValue:"",

            volunteerConstituencyName:"",
            ap_listArr:[{'value':108,'label':'AMADALAVALASA'},{'value':109,'label':'ETCHERLA'},{'value':111,'label':'ICHAPURAM'},{'value':112,'label':'NARASANNAPETA'},{'value':113,'label':'PALAKONDA'},{'value':114,'label':'PATHAPATNAM'},{'value':116,'label':'SRIKAKULAM'},{'value':117,'label':'TEKKALI'},{'value':120,'label':'CHEEPURUPALLI'},{'value':121,'label':'GAJAPATHINAGARAM'},{'value':122,'label':'BOBBILI'},{'value':124,'label':'PARVATHIPURAM'},{'value':125,'label':'SALUR'},{'value':127,'label':'SRUNGAVARAPUKOTA'},{'value':129,'label':'VIZIANAGARAM'},{'value':133,'label':'ANAKAPALLI'},{'value':134,'label':'CHODAVARAM'},{'value':135,'label':'ELAMANCHILI'},{'value':136,'label':'MADUGULA'},{'value':137,'label':'NARSIPATNAM'},{'value':138,'label':'PADERU'},{'value':140,'label':'PAYAKARAOPETA'},{'value':141,'label':'PENDURTHI'},{'value':146,'label':'AMALAPURAM'},{'value':147,'label':'ANAPARTHY'},{'value':149,'label':'JAGGAMPETA'},{'value':152,'label':'KOTHAPETA'},{'value':153,'label':'MUMMIDIVARAM'},{'value':155,'label':'PEDDAPURAM'},{'value':156,'label':'PITHAPURAM'},{'value':157,'label':'PRATHIPAD'},{'value':159,'label':'RAMACHANDRAPURAM'},{'value':160,'label':'RAZOLE'},{'value':163,'label':'TUNI'},{'value':167,'label':'BHIMAVARAM'},{'value':168,'label':'CHINTALAPUDI'},{'value':169,'label':'DENDULUR'},{'value':170,'label':'ELURU'},{'value':171,'label':'GOPALPURAM'},{'value':172,'label':'KOVVUR'},{'value':173,'label':'NARASAPUR'},{'value':174,'label':'PALACOLE'},{'value':176,'label':'POLAVARAM'},{'value':177,'label':'TADEPALLIGUDEM'},{'value':178,'label':'TANUKU'},{'value':179,'label':'UNDI'},{'value':180,'label':'UNGUTUR'},{'value':181,'label':'ACHANTA'},{'value':182,'label':'AVANIGADDA'},{'value':184,'label':'GANNAVARAM (KRISHNA)'},{'value':185,'label':'GUDIVADA'},{'value':186,'label':'JAGGAYYAPET'},{'value':187,'label':'KAIKALUR'},{'value':191,'label':'MYLAVARAM'},{'value':192,'label':'NANDIGAMA'},{'value':193,'label':'NUZVID'},{'value':194,'label':'TIRUVURU'},{'value':195,'label':'VIJAYAWADA EAST'},{'value':196,'label':'VIJAYAWADA WEST'},{'value':199,'label':'CHILAKALURIPET'},{'value':203,'label':'GURZALA'},{'value':205,'label':'MACHERLA'},{'value':206,'label':'MANGALAGIRI'},{'value':207,'label':'VINUKONDA'},{'value':208,'label':'NARASARAOPET'},{'value':209,'label':'BAPATLA'},{'value':210,'label':'PEDDAKURAPADU'},{'value':211,'label':'PONNUR'},{'value':212,'label':'PRATHIPADU'},{'value':213,'label':'REPALLE'},{'value':214,'label':'SATTENAPALLI'},{'value':215,'label':'TADIKONDA'},{'value':216,'label':'TENALI'},{'value':217,'label':'VEMURU'},{'value':218,'label':'ADDANKI'},{'value':219,'label':'CHIRALA'},{'value':221,'label':'DARSI'},{'value':222,'label':'GIDDALUR'},{'value':223,'label':'KANDUKUR'},{'value':224,'label':'KANIGIRI'},{'value':225,'label':'KONDEPI'},{'value':226,'label':'MARKAPUR'},{'value':227,'label':'ONGOLE'},{'value':228,'label':'PARCHUR'},{'value':229,'label':'SANTHANUTHALAPADU'},{'value':231,'label':'GUDUR'},{'value':232,'label':'KAVALI'},{'value':233,'label':'KOVUR'},{'value':236,'label':'SARVEPALLI'},{'value':237,'label':'SULLURPET'},{'value':238,'label':'UDAYAGIRI'},{'value':239,'label':'VENKATAGIRI'},{'value':241,'label':'ATMAKUR'},{'value':242,'label':'BADVEL'},{'value':243,'label':'KADAPA'},{'value':244,'label':'JAMMALAMADUGU'},{'value':245,'label':'KAMALAPURAM'},{'value':246,'label':'KODUR'},{'value':248,'label':'RAYACHOTY'},{'value':249,'label':'MYDUKUR'},{'value':250,'label':'PRODDATUR'},{'value':251,'label':'PULIVENDLA'},{'value':252,'label':'RAJAMPET'},{'value':253,'label':'ADONI'},{'value':254,'label':'ALLAGADDA'},{'value':255,'label':'ALUR'},{'value':257,'label':'DHONE'},{'value':258,'label':'KODUMUR'},{'value':260,'label':'KURNOOL'},{'value':261,'label':'NANDIKOTKUR'},{'value':262,'label':'NANDYAL'},{'value':263,'label':'PANYAM'},{'value':264,'label':'PATTIKONDA'},{'value':265,'label':'YEMMIGANUR'},{'value':267,'label':'DHARMAVARAM'},{'value':270,'label':'HINDUPUR'},{'value':271,'label':'KADIRI'},{'value':272,'label':'KALYANDURG'},{'value':273,'label':'MADAKASIRA'},{'value':275,'label':'PENUKONDA'},{'value':276,'label':'RAYADURG'},{'value':277,'label':'SINGANAMALA'},{'value':278,'label':'TADPATRI'},{'value':279,'label':'URAVAKONDA'},{'value':280,'label':'CHANDRAGIRI'},{'value':281,'label':'CHITTOOR'},{'value':282,'label':'KUPPAM'},{'value':283,'label':'NAGARI'},{'value':284,'label':'PALAMANER'},{'value':285,'label':'PILERU'},{'value':286,'label':'PUNGANUR'},{'value':288,'label':'SATYAVEDU'},{'value':289,'label':'SRIKALAHASTI'},{'value':290,'label':'THAMBALLAPALLE'},{'value':291,'label':'TIRUPATI'},{'value':294,'label':'MADANPALLE'},{'value':297,'label':'GUNTAKAL'},{'value':298,'label':'ANANTAPUR URBAN'},{'value':299,'label':'RAPTADU'},{'value':300,'label':'PUTTAPARTHI'},{'value':301,'label':'GANGADHARA NELLORE'},{'value':302,'label':'PUTHALAPATTU'},{'value':303,'label':'RAJANAGARAM'},{'value':304,'label':'RAJAHMUNDRY CITY'},{'value':305,'label':'RAJAHMUNDRY RURAL'},{'value':306,'label':'RAMPACHODAVARAM'},{'value':307,'label':'KAKINADA RURAL'},{'value':308,'label':'KAKINADA CITY'},{'value':309,'label':'MANDAPETA'},{'value':310,'label':'GANNAVARAM (EG)'},{'value':311,'label':'GUNTUR EAST'},{'value':312,'label':'GUNTUR WEST'},{'value':327,'label':'PEDANA'},{'value':328,'label':'MACHILIPATNAM'},{'value':329,'label':'PAMARRU'},{'value':330,'label':'PENAMALURU'},{'value':331,'label':'VIJAYAWADA CENTRAL'},{'value':332,'label':'SRISAILAM'},{'value':333,'label':'BANAGANAPALLE'},{'value':334,'label':'MANTRALAYAM'},{'value':340,'label':'NELLORE CITY'},{'value':341,'label':'NELLORE RURAL'},{'value':344,'label':'YERRAGONDAPALEM'},{'value':352,'label':'PALASA'},{'value':353,'label':'RAJAM'},{'value':354,'label':'VISAKHAPATNAM EAST'},{'value':355,'label':'VISAKHAPATNAM SOUTH'},{'value':356,'label':'VISAKHAPATNAM NORTH'},{'value':357,'label':'VISAKHAPATNAM WEST'},{'value':358,'label':'GAJUWAKA'},{'value':359,'label':'ARAKU VALLEY'},{'value':360,'label':'KURUPAM'},{'value':361,'label':'NELLIMARLA'},{'value':366,'label':'NIDADAVOLE'},{'value':368,'label':'BHIMILI'}],
            SelfconstituencyValue:"",

            SelfMandalMunValue:"",
            volunteerMandalMunName:"",
            mandalMunArr:[{'value':1,'label':'Mandal Name'}],

            mahaShaktiCheckedCond:"",
            annaDataCheckedCond:"",
            yuvvaGalamCheckedCond:"",

            yuvaGalamCheckBox:false,

            annaDataCardId :"",
            yuvaGalamCardId:"",
            mahaShaktiCardId:"",

            preferencesObj:[{"schemeCode": "INTINTKI_WATER","interested": true,"cardId": "" },{"schemeCode": "POOR_TO_RICH","interested": true,"cardId": "" }],
            schemeCheckVerified:0,

            validateVolunteerPhysicalCardId:"",
            validateVolunteerName:"",
            validateVolunteerGender:"",
            validateVolunteerAge:"",
            validateVolunteerOccupation:"",
            validateVolunteerMobile:"",
            validateVolunteerVoterCard:"",
            validateVolunteerConstituencyName:"",
            validateVolunteerPincode:"",
            validateVolunteerMandalMunName:"",
            validateVolunteerOTP:"",
            validateVolunteerAddress:"",
            validateInterests:"",

            selfOptionScreenType:"slide_one",
            selfOptionLoderSymbolSave:"hide",
            selfOptionMessageSave:"",
            yuvvaGalamCheckedUnemployedModal:false,
            getCurrentLocationCoordinatesForDV:{},

            smsSentMessage:"",
            otpVerifiedMessageStatus:"",
            otpLoadingSymbol:"hide",
            getOTPLoadingSymbol:"hide",
            OTPSentStatus:"",
            resendOTPLoadingSymbol:"hide",
            resendSmsSentMessage:"",
            
            minutes:1,
            seconds:0,
            successPageModal:false,

            audioSourceURL:"",
            base64StrVoiceRecorded:"",
            recordedMsg:"",

            casteListArr:[{'value':1,'label':'OC'},{'value':2,'label':'BC'},{'value':3,'label':'SC'},{'value':4,'label':'ST'},{'value':5,'label':'Minority'},{'value':'','label':'Not Interested'}],
            casteStr:"",
            casteValue:{'value':'','label':'Not Interested'},

            bcProtectionLawCheckBox:false,
            annaDataCheckBox:false,
            yuvaGagalamCheckBox:false,
            mahaShaktiCheckBox:false,
            smsForBG:"",

            NOOfChildrens:0,
            validateNOOfChildrens:"",

            qrCodeUUID:"",

            noOfWomen:0,
            noOfUnEmployed:0,
            noofFarmers:0,
            totalFamilyMembers:0,
            validatenoOfWomen:"",
            validatenoOfUnEmployed:"",
            validatetotalFamilyMembers:"",

            validateCaste:"",

            cardNoSymbol:"hide",

            volunteerSearchBoothName:"",
            SearchBoothValue:"",
            searchOptionBoothListArr:[],
            boothsLoadingSymbol:"hide",
            
            
        }
        this.checkInterestValue = this.checkInterestValue.bind(this);
    }

    componentDidMount() {
       
        /*const getUID = (length=5) => {
            var result           = '';
            var characters       = '0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }
        const BGCardId = "6666120"+getUID();
        this.setState({ volunteerPhysicalCardId:BGCardId});*/

        console.log("ap_listArr",this.state.ap_listArr)
        this.getOccupations();
        navigator.geolocation.getCurrentPosition(this.showLocationDVMappingPostions,this.ShowLocationPermissionError)
       
    }

    getOccupations = () => {
        fetch(`https://projectkv.com/bot_api/v1/occupations`, {
            method: "GET", 
            mode: "cors", 
            cache: "no-cache", 
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "test_chat_id" :"5129193582",
            },
          })
          .then((res) => res.json())
          .then((json) => {
              if(json !=null && json.length>0){
                var occupationArr=[];
                for(var i in  json){
                    var obj={'value':json[i].occupationCode,'label':json[i].occupationName};
                    occupationArr.push(obj)
                    
                }
               
                this.setState({ occupationListArr:occupationArr});
              }
            
          });
    }

    handleOnchangeSelectBox = (e) => {
        const name = e.target.name;
        const value = e.target.value;
    
        this.setState({ [name]: value });
        
        
      }

      handleOnchangeInputBox = (e) => {
        this.setState({validateInterests:"" });
        console.log("handleInputChange", e.target.name, e.target.value)
        const name = e.target.name;
        const value = e.target.value;
        const re = /^[0-9\b]+$/;
        

       
        if(name == "volunteerOTPNO"){
            if(value.length >= 6){
                this.validateMobileOtp(value);
            }
            
        }else if(name == "noOfWomen"){
            let MAHA_SHAKTI = this.state.preferencesObj.filter(a => a.schemeCode == "MAHA_SHAKTI").map(b => b.schemeCode);
            if(value > 0){
                this.setState({ mahaShaktiCheckBox:true});
                if(MAHA_SHAKTI.length==0){
                    this.setState(({preferencesObj}) => ({  
                        preferencesObj: [...preferencesObj, {
                        "schemeCode": "MAHA_SHAKTI",
                        "interested": true,
                        "cardId": ""
                    }]
                    }));
                }
                
            }else if(value == 0 || value == ""){ 
                this.setState({ mahaShaktiCheckBox:false});
                const itemToBeRemoved = {"schemeCode": "MAHA_SHAKTI","interested": true,"cardId": "" };
                this.state.preferencesObj.forEach((item, index) => {
                    if (item.schemeCode == itemToBeRemoved.schemeCode) {
                        this.state.preferencesObj.splice(index, 1);
                    }
                });
            }
            
        }else if(name == "noOfUnEmployed"){
            let YUVA_GALAM = this.state.preferencesObj.filter(a => a.schemeCode == "YUVA_GALAM").map(b => b.schemeCode);
            if(value > 0){
                this.setState({ yuvaGagalamCheckBox:true});
                if(YUVA_GALAM.length==0){
                    this.setState(({preferencesObj}) => ({  
                        preferencesObj: [...preferencesObj, {
                        "schemeCode": "YUVA_GALAM",
                        "interested": true,
                        "cardId": ""
                    }]
                    }));
                }
                
            }else if(value == 0 || value == ""){ 
                this.setState({ yuvaGagalamCheckBox:false});
                const itemToBeRemoved = {"schemeCode": "YUVA_GALAM","interested": true,"cardId": "" };
                this.state.preferencesObj.forEach((item, index) => {
                    if (item.schemeCode == itemToBeRemoved.schemeCode) {
                        this.state.preferencesObj.splice(index, 1);
                    }
                });
            }
            
        }

        

        this.setState({ [name]: value });
        
      }

      handleOnchangeAllowNumbersInputBox = (e) => {
        this.setState({validateInterests:"",validateVolunteerPhysicalCardId:"",validateNOOfChildrens:"",validatenoOfWomen:"",validatenoOfUnEmployed:"",validatetotalFamilyMembers:"" });
        const name = e.target.name;
        const value = e.target.value;
        const re = /^[0-9\b]+$/;

        if(name == "mahaShaktiCardId"){
            if (!re.test(e.target.value)) {
                this.setState({validateInterests:"Please Enter Numbers Only...  ",mahaShaktiCardId:"" });
                return;
            }else if(value.length >=12){
                if (this.state.mahaShaktiCardId < 666600000001 || this.state.mahaShaktiCardId > 666699999999){
                    this.setState({validateInterests:"MahaShakti Range In Between 666600000001 to 666699999999" });
                    return;
                }else{
                    this.setState({validateInterests:"" });
                }
            }else if (this.state.mahaShaktiCardId.length < 12){
                this.setState({validateInterests:"Please Enter 12 Digit CardNo..." });
                return;
            }else{
                this.setState({validateInterests:"" });
            }

        }else if(name == "annaDataCardId"){
            if (!re.test(e.target.value)) {
                this.setState({validateInterests:"Please Enter Numbers Only...  ",annaDataCardId:"" });
                return;
            }else if(value.length >=12){
                if (this.state.annaDataCardId < 666600000001 || this.state.annaDataCardId > 666699999999){
                    this.setState({validateInterests:"AnnaData Range In Between 666600000001 to 666699999999" });
                    return;
                }else{
                    this.setState({validateInterests:"" });
                }
            }else if (this.state.annaDataCardId.length < 12){
                this.setState({validateInterests:"Please Enter 12 Digit CardNo..." });
                return;
            }else{
                this.setState({validateInterests:"" });
            }
        }else if(name == "yuvaGalamCardId"){
            if (!re.test(e.target.value)) {
                this.setState({validateInterests:"Please Enter Numbers Only...  ",yuvaGalamCardId:"" });
                return;
            }else if(value.length >=12){
                if (this.state.yuvaGalamCardId < 666600000001 || this.state.yuvaGalamCardId > 666699999999){
                    this.setState({validateInterests:"YuvaGalam Range In Between 666600000001 to 666699999999" });
                    return;
                }else{
                    this.setState({validateInterests:"" });
                }
            }else if (this.state.yuvaGalamCardId.length < 12){
                this.setState({validateInterests:"Please Enter 12 Digit CardNo..." });
                return;
            }else{
                this.setState({validateInterests:"" });
            }
        }else if(name == "volunteerPhysicalCardId"){
            if (!re.test(e.target.value)) {
                this.setState({validateVolunteerPhysicalCardId:"Please Enter Numbers Only...  ",volunteerPhysicalCardId:""});
                return;
            }else if (this.state.volunteerPhysicalCardId.length < 12){
                this.setState({validateVolunteerPhysicalCardId:"Please Enter 12 Digit CardNo..." });
                return;
            }else{
                this.setState({validateInterests:"" });
                this.setState({validateVolunteerPhysicalCardId:"" });
            }
        }else if(name == "NOOfChildrens"){
            if (!re.test(e.target.value)) {
                this.setState({validateNOOfChildrens:"Please Enter Numbers Only...  ",NOOfChildrens:""});
                return;
            }else{
                this.setState({validateNOOfChildrens:""});
            }
        }else if(name == "noOfWomen"){
            if (!re.test(e.target.value)) {
                this.setState({validatenoOfWomen:"Please Enter Numbers Only...  ",noOfWomen:0});
                return;
            }else{
                this.setState({validatenoOfWomen:""});
            }
        }else if(name == "noOfUnEmployed"){
            if (!re.test(e.target.value)) {
                this.setState({validatenoOfUnEmployed:"Please Enter Numbers Only...  ",noOfUnEmployed:""});
                return;
            }else{
                this.setState({validatenoOfUnEmployed:""});
            }
        }else if(name == "totalFamilyMembers"){
            if (!re.test(e.target.value)) {
                this.setState({validatetotalFamilyMembers:"Please Enter Numbers Only...  ",totalFamilyMembers:""});
                return;
            }else{
                this.setState({validatetotalFamilyMembers:""});
            }
        }else{
            this.setState({validateInterests:"" });
        }
      }

      getFutureGuaranteeEnrollmentNumber = (constituencyId) => {
        this.setState({cardNoSymbol:"show" });
        
        const obj =  
        JSON.stringify({ 
            "chatId" :'943827154',
            "constituencyId" : constituencyId,
        }); 

        getAPICallData(obj,"getFutureGuaranteeEnrollmentNumber")
        .then((res) => res.json())
        .then((data) => {
            this.setState({cardNoSymbol:"hide" });
          if(data !=null && data.name == "Success"){
            this.setState({ volunteerPhysicalCardId:data.id});
          }else{
            this.setState({ volunteerPhysicalCardId:""});
          }
        });
    }   
  handleOnchangeSelectBoxNew = (ename, evalue) =>{
    const name = ename;
    const value = evalue;
    this.setState({ validateVolunteerPhysicalCardId:"",
                        validateVolunteerName:"",
                        validateVolunteerGender:"",
                        validateVolunteerAge:"",
                        validateVolunteerOccupation:"",
                        validateVolunteerMobile:"",
                        validateVolunteerVoterCard:"",
                        validateVolunteerConstituencyName:"",
                        validateVolunteerPincode:"",
                        validateVolunteerOTP:"",
                        validateVolunteerMandalMunName:"",
                        validateVolunteerAddress:"",
                        validateInterests:"",
                        validateNOOfChildrens:"",
                        validatenoOfWomen:"",
                        validatenoOfUnEmployed:"",
                        validateCaste:"",
                        validatetotalFamilyMembers:""
                    });

    if(name == "volunteerConstituencyName"){
      let getConsIdName = this.state.ap_listArr.find((a) => a.value == value);
        this.setState({
          SelfconstituencyValue: {
              value: getConsIdName.value,
              label: getConsIdName.label
          }
      });
     this.getFutureGuaranteeEnrollmentNumber(value);
     this.serchOptionGetBooths(value);

    }else if(name == "volunteerOccupation"){
        let getOccIdName = this.state.occupationListArr.find((a) => a.value == value);
        this.setState({
            occupationValue: {
              value: getOccIdName.value,
              label: getOccIdName.label
          }
      });

      if(value == "FARMER_AGRICULTURE" || value == "Farmer_Tenant"){
        this.setState({ annaDataCheckBox:true});
        let existedAnnaDataData = this.state.preferencesObj.filter(a => a.schemeCode == "RYTHU_NESTAM").map(b => b.schemeCode);
        if(existedAnnaDataData.length == 0){
            this.setState(({preferencesObj}) => ({  
                preferencesObj: [...preferencesObj, {
                "schemeCode": "RYTHU_NESTAM",
                "interested": true,
                "cardId": ""
            }]
            }));
        }
        
       
       
      }else if (value != "FARMER_AGRICULTURE" || value != "Farmer_Tenant"){
        const itemToBeRemoved = {"schemeCode": "RYTHU_NESTAM","interested": true,"cardId": "" };
        this.state.preferencesObj.forEach((item, index) => {
            if (item.schemeCode == itemToBeRemoved.schemeCode) {
                this.state.preferencesObj.splice(index, 1);
            }
        });
        this.setState({ annaDataCheckBox:false});

      }

      if(value == "Unemployed"){
        this.setState({ yuvaGagalamCheckBox:true});
        this.setState(({preferencesObj}) => ({  
            preferencesObj: [...preferencesObj, {
            "schemeCode": "YUVA_GALAM",
            "interested": true,
            "cardId": ""
        }]
        }));
       
       
      }else if (value != "Unemployed"){
        const itemToBeRemoved = {"schemeCode": "YUVA_GALAM","interested": true,"cardId": "" };
        this.state.preferencesObj.forEach((item, index) => {
            if (item.schemeCode == itemToBeRemoved.schemeCode) {
                this.state.preferencesObj.splice(index, 1);
            }
        });
        this.setState({ yuvaGagalamCheckBox:false});

      }

    }else if(name == "volunteerMandalMunName"){
        let getManIdName = this.state.mandalMunArr.find((a) => a.value == value);
        this.setState({
            SelfMandalMunValue: {
              value: getManIdName.value,
              label: getManIdName.label
          }
      });
    }else if(name == "casteStr"){
        let getCasteIdName = this.state.casteListArr.find((a) => a.value == value);
        this.setState({
            casteValue: {
              value: getCasteIdName.value,
              label: getCasteIdName.label
          }
      });

      if(value == 2){
        this.setState({ bcProtectionLawCheckBox:true});
        this.setState(({preferencesObj}) => ({  
            preferencesObj: [...preferencesObj, {
            "schemeCode": "BC_PROTECTION",
            "interested": true,
            "cardId": ""
        }]
        }));
       
       
      }else if (value != 2){
        const itemToBeRemoved = {"schemeCode": "BC_PROTECTION","interested": true,"cardId": "" };
        this.state.preferencesObj.forEach((item, index) => {
            if (item.schemeCode == itemToBeRemoved.schemeCode) {
                this.state.preferencesObj.splice(index, 1);
            }
        });
        this.setState({ bcProtectionLawCheckBox:false});

      }
      

     /* this.setState({ preferencesObj:[{"schemeCode": "INTINTKI_WATER","interested": true,"cardId": "" },
                                    {"schemeCode": "POOR_TO_RICH","interested": true,"cardId": "" },
                                    {"schemeCode": "BC_PROTECTION","interested": true,"cardId": "" }]
        });*/
    }else if(name == "volunteerSearchBoothName"){
        let getBoothIdName = this.state.searchOptionBoothListArr.find((a) => a.value == value);
        this.setState({
            SearchBoothValue: {
            value: getBoothIdName.value,
            label: getBoothIdName.label
        }
    });
    }

    this.setState({ [name]: value});
  }


  
  serchOptionGetBooths = (value) => {
    this.setState({ searchOptionBoothListArr: [],boothsLoadingSymbol:"show"});

    fetch(`https://projectkv.com/bot_api/v1/booth?constituency_id=${value}`, {
        method: "GET", 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'user_data':'user_data',
            "test_chat_id" :"5129193582",
        },
      })
      .then((res) => res.json())
      .then((json) => {
        this.setState({ boothsLoadingSymbol:"hide"});
          if(json !=null && json.length>0){
            var boothArr=[];
            for(var i in  json){
                var obj={'value':json[i].boothId,'label':"Booth"+json[i].partNo};
                boothArr.push(obj)
                
            }
           
            this.setState({ searchOptionBoothListArr:boothArr });
          }
        
      });
  }

  proccedForRegistrationYG = (resType) => {
    this.setState({ yuvvaGalamCheckedUnemployedModal:false});
    if(resType == "no"){
       this.setState({ yuvvaGalamCheckedCond:"",yuvaGalamCheckBox: !this.state.yuvaGalamCheckBox});
    }
  }

  checkInterestValue = (e,interestType,interestName) => {
    

    if(e.target.checked){
        if(interestType == 1){
            this.setState({ mahaShaktiCheckedCond:1,mahaShaktiCheckBox:true});
        }else if(interestType == 3){
            this.setState({ annaDataCheckedCond:3,annaDataCheckBox:true,noofFarmers:1});
            let getOccIdName = this.state.occupationListArr.find((a) => a.value == "FARMER_AGRICULTURE");
            this.setState({
                occupationValue: {
                    value: getOccIdName.value,
                    label: getOccIdName.label
                }
            });
             this.setState({ volunteerOccupation:getOccIdName.value});
        }else if(interestType == 2){
            this.setState({ yuvvaGalamCheckedCond:2,yuvaGagalamCheckBox:true});
        }else if(interestType == 6){
            this.setState({ bcProtectionLawCheckBox:true});
        }

        this.setState(({preferencesObj}) => ({
            preferencesObj: [...preferencesObj, {
            "schemeCode": interestName,
            "interested": true,
            "cardId": ""
        }]
        }));
    } else {
        if(interestType == 1){
            this.setState({ mahaShaktiCheckedCond:"",mahaShaktiCheckBox:!this.state.mahaShaktiCheckBox,noOfWomen:0}); 
        }else if(interestType == 3){
            this.setState({occupationValue:"",volunteerOccupation:"",annaDataCheckedCond:"",annaDataCheckBox:!this.state.annaDataCheckBox,noofFarmers:0});
        }else if(interestType == 2){
            this.setState({yuvvaGalamCheckedCond:"",yuvaGagalamCheckBox:!this.state.yuvaGagalamCheckBox,noOfUnEmployed:0});
        }else if(interestType == 6){
            this.setState({ bcProtectionLawCheckBox:!this.state.bcProtectionLawCheckBox});
        }
        this.setState(({preferencesObj}) => ({
            preferencesObj: preferencesObj.filter((element) =>  (interestName !== element.schemeCode))
        }));
    }

    

  }
  showLocationDVMappingPostions = (position) => {
    const getCoordinates =  
        { 
        "latitude" : position.coords.latitude,
        "longitude" : position.coords.longitude,
        "accuracy":position.coords.accuracy
        }
        
    this.setState({getCurrentLocationCoordinatesForDV:getCoordinates});
}

    ShowLocationPermissionError = (error) => {
        switch (error.code){
            case error.PERMISSION_DENIED:
            alert("User Location Permission is Denied,Please Enable Location Services...(Path:Settings > Privacy > Location Services)");
            break;

            case error.POSITION_UNAVAILABLE:
            alert("User Postion Unavailable Denied");
            break;

            default:
                alert("An unknown error occurred")
        }
    }

      getSelfPhyicalCard = () => {
        
        let obj1={};
        this.setState({ validateVolunteerPhysicalCardId:"",
                        validateVolunteerName:"",
                        validateVolunteerGender:"",
                        validateVolunteerAge:"",
                        validateVolunteerOccupation:"",
                        validateVolunteerMobile:"",
                        validateVolunteerVoterCard:"",
                        validateVolunteerConstituencyName:"",
                        validateVolunteerPincode:"",
                        validateVolunteerOTP:"",
                        validateVolunteerMandalMunName:"",
                        validateVolunteerAddress:"",
                        validateInterests:"",
                        validateNOOfChildrens:"",
                        validatenoOfWomen:"",
                        validatenoOfUnEmployed:"",
                        validateCaste:"",
                        validatetotalFamilyMembers:""
                    });

        /*if(this.state.schemeCheckVerified == 0){
            this.setState({validateInterests:"Please Select Atleast One Scheme...." });
            return;
        }


        //MahaShakti
        if(this.state.mahaShaktiCheckedCond == 1 && this.state.mahaShaktiCardId == "" ){
            this.setState({validateInterests:"Please Enter MahaShakti Card No..." });
            return;
        } 

        if(this.state.mahaShaktiCheckedCond == "" && this.state.mahaShaktiCardId != "" ){
            this.setState({validateInterests:"Please Check MahaShakti CheckBox..." });
            return;
        }

        if(this.state.mahaShaktiCheckedCond == 1 && this.state.mahaShaktiCardId != "" ){
            if (this.state.mahaShaktiCardId.match(/[a-z]/i)){
                this.setState({validateInterests:"Please Enter Numbers Only..." });
                return;
            }
        }

        if(this.state.mahaShaktiCheckedCond == 1 && this.state.mahaShaktiCardId != "" ){
            if (this.state.mahaShaktiCardId.length < 12){
                this.setState({validateInterests:"Please Enter 12 Digit CardNo..." });
                return;
            }
        }

        if(this.state.mahaShaktiCheckedCond == 1 && this.state.mahaShaktiCardId != "" ){
            if (this.state.mahaShaktiCardId < 666600000001 || this.state.mahaShaktiCardId > 666699999999){
                this.setState({validateInterests:"MahaShakti Card No In Between 666600000001 to 666699999999" });
                return;
            }
        }
        console.log("dddddddweeeeeeeeeee",this.state.mahaShaktiCheckedCond)
        if(this.state.mahaShaktiCheckedCond == 1){
            obj1 ={
            "schemeCode": "MAHA_SHAKTI",
            "interested": true,
            "cardId": this.state.mahaShaktiCardId
            }
            interestArr.push(obj1);
            console.log("dddddddweeeeeeeeeee",this.state.preferencesObj)
            this.setState({ preferencesObj:interestArr,schemeCheckVerified:1});

        }

        //YuvaGalam
        if(this.state.yuvvaGalamCheckedCond == 2 && this.state.yuvaGalamCardId == "" ){
            this.setState({validateInterests:"Please Enter YuvaGalam Card No  " });
            return;
        } 


        if(this.state.yuvvaGalamCheckedCond == "" && this.state.yuvaGalamCardId != "" ){
            this.setState({validateInterests:"Please Check YuvaGalam CheckBox..." });
            return;
        }

        if(this.state.yuvvaGalamCheckedCond == 1 && this.state.yuvaGalamCardId != "" ){
            if (this.state.yuvaGalamCardId.match(/[a-z]/i)){
                this.setState({validateInterests:"Please Enter Numbers Only..." });
                return;
            }
        }

        if(this.state.yuvvaGalamCheckedCond == 2 && this.state.yuvaGalamCardId != "" ){
            if (this.state.yuvaGalamCardId.length < 12){
                this.setState({validateInterests:"Please Enter 12 Digit CardNo..." });
                return;
            }
        }

        if(this.state.yuvvaGalamCheckedCond == 2 && this.state.yuvaGalamCardId != "" ){
            if (this.state.yuvaGalamCardId < 666600000001 || this.state.yuvaGalamCardId > 666699999999){
                this.setState({validateInterests:"YuvaGalam Card No In Between 666600000001 to 666699999999" });
                return;
            }
        } 
        if(this.state.yuvvaGalamCheckedCond == 2){
            obj1 ={
            "schemeCode": "YUVA_GALAM",
            "interested": true,
            "cardId": this.state.yuvaGalamCardId
            }
            interestArr.push(obj1);
            this.setState({ preferencesObj:interestArr,schemeCheckVerified:1 });
        }

        //AnnaData
        if(this.state.annaDataCheckedCond == 3 && this.state.annaDataCardId == "" ){
            this.setState({validateInterests:"Please Enter AnnaData Card No  " });
            return;
        } 


        if(this.state.annaDataCheckedCond == "" && this.state.annaDataCardId != "" ){
            this.setState({validateInterests:"Please Check AnnaData CheckBox..." });
            return;
        }

        if(this.state.annaDataCheckedCond == 1 && this.state.annaDataCardId != "" ){
            if (this.state.annaDataCardId.match(/[a-z]/i)){
                this.setState({validateInterests:"Please Enter AnnaData Only..." });
                return;
            }
        }

        if(this.state.annaDataCheckedCond == 3 && this.state.annaDataCardId != "" ){
            if (this.state.annaDataCardId.length < 12){
                this.setState({validateInterests:"Please Enter 12 Digit CardNo..." });
                return;
            }
        }

        if(this.state.annaDataCheckedCond == 3 && this.state.annaDataCardId != "" ){
            if (this.state.annaDataCardId < 666600000001 || this.state.annaDataCardId > 666699999999){
                this.setState({validateInterests:"AnnaData Card No In Between 666600000001 to 666699999999" });
                return;
            }
        }
        
        if(this.state.annaDataCheckedCond == 3){
            obj1 ={
            "schemeCode": "RYTHU_NESTAM",
            "interested": true,
            "cardId": this.state.annaDataCardId
            }
            interestArr.push(obj1);
            this.setState({ preferencesObj:interestArr,schemeCheckVerified:1 });
        }*/

        if(this.state.volunteerSearchBoothName == "" || this.state.volunteerSearchBoothName == 0){
            scroller.scrollTo("scroll_top", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
            this.setState({validateSearchByBoothNo:"Please Select Booth" });
            return;
        }
        if(this.state.volunteerConstituencyName == "" || this.state.volunteerConstituencyName == 0){
            scroller.scrollTo("scroll_top", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
            this.setState({validateVolunteerConstituencyName:"Please Select Constituency Name" });
            return;
        }

        if(this.state.volunteerName == ""){
            scroller.scrollTo("scroll_top", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
            this.setState({validateVolunteerName:"Please Enter Name" });
            return;
        }

        if(this.state.volunteerGender == ""){
            scroller.scrollTo("scroll_top", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
            this.setState({validateVolunteerGender:"Please Select Gender" });
            return;
        }

        if(this.state.volunteerAge == ""){
            scroller.scrollTo("scroll_top", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
            this.setState({validateVolunteerAge:"Please Enter Age" });
            return;
        }

        if(!this.state.volunteerAge.match(/^[1-9]?[0-9]{1}$|^100$/)){
            this.setState({validateVolunteerAge:"Please Enter Valid Age" });
            return;
        }

        if(this.state.mahaShaktiCheckedCond == 1){
           
            if (isNaN(this.state.volunteerAge) || this.state.volunteerAge < 18 || this.state.volunteerAge > 59){
                scroller.scrollTo("scroll_top", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateVolunteerAge:"age in between 18 to 59" });
                return;
            }
        }
       /* if(this.state.yuvvaGalamCheckedCond == 2){
            if (isNaN(this.state.volunteerAge) || this.state.volunteerAge < 18 || this.state.volunteerAge > 35){
                this.setState({validateVolunteerAge:"age in between 18 to 35" });
                return;
            }
        }*/

        /*if(this.state.volunteerGender == "F" ||  this.state.volunteerGender == "f" || this.state.volunteerGender == "female"){
            if(this.state.NOOfChildrens == ""){
                this.setState({validateNOOfChildrens:"Please Enter No Of Childrens" });
                return;
            }
        }*/

        if(this.state.volunteerOccupation == "" || this.state.volunteerOccupation == 0){
            scroller.scrollTo("scroll_two", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
            this.setState({validateVolunteerOccupation:"Please Select Occupation" });
            return;
        }
       
        
       /* if(this.state.casteStr == "" || this.state.casteStr == 0){
            scroller.scrollTo("scroll_two", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
            this.setState({validateCaste:"Please Select Caste" });
            return;
        }*/
        

        /*if(this.state.volunteerVoterCard == ""){
            this.setState({validateVolunteerVoterCard:"Please Enter Voter Card Id" });
            return;
        }*/

        if(this.state.volunteerMobile == ""){
            this.setState({validateVolunteerMobile:"Please Enter Mobile No" });
            return;
        }
        if(!this.state.volunteerMobile.match(/^[0-9]+$/)){
            this.setState({validateVolunteerMobile:"Please Enter Valid Mobile No" });
            return;
        }

        if(this.state.volunteerMobile.length < 10){
            this.setState({validateVolunteerMobile:"Please Enter Valid Mobile No" });
            return;
        }


        if(this.state.volunteerOTPNO == ""){
            this.setState({validateVolunteerOTP:"Please Enter OTP" });
            return;
        }

        if(this.state.volunteerOTPNO.length < 6){
            this.setState({validateVolunteerOTP:"Please Enter Valid OTP" });
            return;
        }

        if(this.state.otpVerifiedMessageStatus == "NotVerified"){
            this.setState({validateVolunteerOTP:"Please Enter Valid OTP" });
            return;
        }
        

        this.setState({selfOptionLoderSymbolSave:"show"})

        fetch('https://projectkv.com/bot_api/v1/webEnroll', {
            method: "POST", 
            mode: "cors", 
            cache: "no-cache", 
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
               // "test_chat_id" :"5129193582",
            },
            body: JSON.stringify({
                "mgid": parseInt(this.state.volunteerPhysicalCardId),
                "name": this.state.volunteerName,
                "age": parseInt(this.state.volunteerAge),
                "gender": this.state.volunteerGender,
                "occupation": this.state.volunteerOccupation.label,
                "occupationCode": this.state.occupationValue.value,
                "mobileNo": this.state.volunteerMobile,
                "verified": true,
                "constituencyId": this.state.volunteerConstituencyName,
                "pinCode": this.state.volunteerPincode,
                "voterCardId": this.state.volunteerVoterCard,
                "mandalId": 0,
                "townId": 0,
                "address": this.state.volunteerAddress,
                "latitude": this.state.getCurrentLocationCoordinatesForDV.latitude,
                "longitude": this.state.getCurrentLocationCoordinatesForDV.longitude,
                "interestedSchemes": this.state.preferencesObj,
                "noOfChildren": this.state.NOOfChildrens,
                "noOfWomen": this.state.noOfWomen,
                "noOfUnEmployed": this.state.noOfUnEmployed,
                "noOfFarmers":this.state.noofFarmers,
                "totalFamilyMembers": this.state.totalFamilyMembers,
                "boothId": this.state.volunteerSearchBoothName,
            }), 
          })

          .then((response) => {
            this.setState({selfOptionLoderSymbolSave:"hide"})
            // 1. check response.ok
            if (response.ok) {
              return response.json();
            }
            return Promise.reject(response); // 2. reject instead of throw
          })
          .then((json) => {
            // all good, token is ready
            this.sendSMSForFutureGuaranteeProgram(json.shortUrlCode,json.qrCodeUUID);
            this.setState({selfOptionMessageSave:""});
            setTimeout(() => {
                this.props.history.push({
                    pathname: `/profile_details_page`,
                    params: {
                        qrCodeUUID:json.qrCodeUUID,
                        enrollId:json.shortUrlCode
                      },
                }); 
            }, 1500);
          })
          .catch((response) => {
            this.setState({selfOptionMessageSave:"Something Wrong,Please Try Again..."});
            // 3. get error messages, if any
            response.json().then((json) => {
                this.setState({selfOptionMessageSave:"Something Wrong,Please Try Again..."});
            })
          });

        
      }

      backToEnrollPage = () => {
        this.setState({successPageModal:false});
        this.setState({ 
                        volunteerPhysicalCardId:"",
                        volunteerName:"",
                        volunteerGender:"",
                        volunteerAge:"",
                        volunteerMobile:"",
                        volunteerOTPNO:"",
                        volunteerVoterCard:"",
                        volunteerPincode:"",
                        volunteerAddress:"",

                        volunteerOccupation:"",
                        occupationListArr:[],
                        occupationValue:"",

                        volunteerConstituencyName:"",
                        ap_listArr:[{'value':108,'label':'AMADALAVALASA'},{'value':109,'label':'ETCHERLA'},{'value':111,'label':'ICHAPURAM'},{'value':112,'label':'NARASANNAPETA'},{'value':113,'label':'PALAKONDA'},{'value':114,'label':'PATHAPATNAM'},{'value':116,'label':'SRIKAKULAM'},{'value':117,'label':'TEKKALI'},{'value':120,'label':'CHEEPURUPALLI'},{'value':121,'label':'GAJAPATHINAGARAM'},{'value':122,'label':'BOBBILI'},{'value':124,'label':'PARVATHIPURAM'},{'value':125,'label':'SALUR'},{'value':127,'label':'SRUNGAVARAPUKOTA'},{'value':129,'label':'VIZIANAGARAM'},{'value':133,'label':'ANAKAPALLI'},{'value':134,'label':'CHODAVARAM'},{'value':135,'label':'ELAMANCHILI'},{'value':136,'label':'MADUGULA'},{'value':137,'label':'NARSIPATNAM'},{'value':138,'label':'PADERU'},{'value':140,'label':'PAYAKARAOPETA'},{'value':141,'label':'PENDURTHI'},{'value':146,'label':'AMALAPURAM'},{'value':147,'label':'ANAPARTHY'},{'value':149,'label':'JAGGAMPETA'},{'value':152,'label':'KOTHAPETA'},{'value':153,'label':'MUMMIDIVARAM'},{'value':155,'label':'PEDDAPURAM'},{'value':156,'label':'PITHAPURAM'},{'value':157,'label':'PRATHIPAD'},{'value':159,'label':'RAMACHANDRAPURAM'},{'value':160,'label':'RAZOLE'},{'value':163,'label':'TUNI'},{'value':167,'label':'BHIMAVARAM'},{'value':168,'label':'CHINTALAPUDI'},{'value':169,'label':'DENDULUR'},{'value':170,'label':'ELURU'},{'value':171,'label':'GOPALPURAM'},{'value':172,'label':'KOVVUR'},{'value':173,'label':'NARASAPUR'},{'value':174,'label':'PALACOLE'},{'value':176,'label':'POLAVARAM'},{'value':177,'label':'TADEPALLIGUDEM'},{'value':178,'label':'TANUKU'},{'value':179,'label':'UNDI'},{'value':180,'label':'UNGUTUR'},{'value':181,'label':'ACHANTA'},{'value':182,'label':'AVANIGADDA'},{'value':184,'label':'GANNAVARAM (KRISHNA)'},{'value':185,'label':'GUDIVADA'},{'value':186,'label':'JAGGAYYAPET'},{'value':187,'label':'KAIKALUR'},{'value':191,'label':'MYLAVARAM'},{'value':192,'label':'NANDIGAMA'},{'value':193,'label':'NUZVID'},{'value':194,'label':'TIRUVURU'},{'value':195,'label':'VIJAYAWADA EAST'},{'value':196,'label':'VIJAYAWADA WEST'},{'value':199,'label':'CHILAKALURIPET'},{'value':203,'label':'GURZALA'},{'value':205,'label':'MACHERLA'},{'value':206,'label':'MANGALAGIRI'},{'value':207,'label':'VINUKONDA'},{'value':208,'label':'NARASARAOPET'},{'value':209,'label':'BAPATLA'},{'value':210,'label':'PEDDAKURAPADU'},{'value':211,'label':'PONNUR'},{'value':212,'label':'PRATHIPADU'},{'value':213,'label':'REPALLE'},{'value':214,'label':'SATTENAPALLI'},{'value':215,'label':'TADIKONDA'},{'value':216,'label':'TENALI'},{'value':217,'label':'VEMURU'},{'value':218,'label':'ADDANKI'},{'value':219,'label':'CHIRALA'},{'value':221,'label':'DARSI'},{'value':222,'label':'GIDDALUR'},{'value':223,'label':'KANDUKUR'},{'value':224,'label':'KANIGIRI'},{'value':225,'label':'KONDEPI'},{'value':226,'label':'MARKAPUR'},{'value':227,'label':'ONGOLE'},{'value':228,'label':'PARCHUR'},{'value':229,'label':'SANTHANUTHALAPADU'},{'value':231,'label':'GUDUR'},{'value':232,'label':'KAVALI'},{'value':233,'label':'KOVUR'},{'value':236,'label':'SARVEPALLI'},{'value':237,'label':'SULLURPET'},{'value':238,'label':'UDAYAGIRI'},{'value':239,'label':'VENKATAGIRI'},{'value':241,'label':'ATMAKUR'},{'value':242,'label':'BADVEL'},{'value':243,'label':'KADAPA'},{'value':244,'label':'JAMMALAMADUGU'},{'value':245,'label':'KAMALAPURAM'},{'value':246,'label':'KODUR'},{'value':248,'label':'RAYACHOTY'},{'value':249,'label':'MYDUKUR'},{'value':250,'label':'PRODDATUR'},{'value':251,'label':'PULIVENDLA'},{'value':252,'label':'RAJAMPET'},{'value':253,'label':'ADONI'},{'value':254,'label':'ALLAGADDA'},{'value':255,'label':'ALUR'},{'value':257,'label':'DHONE'},{'value':258,'label':'KODUMUR'},{'value':260,'label':'KURNOOL'},{'value':261,'label':'NANDIKOTKUR'},{'value':262,'label':'NANDYAL'},{'value':263,'label':'PANYAM'},{'value':264,'label':'PATTIKONDA'},{'value':265,'label':'YEMMIGANUR'},{'value':267,'label':'DHARMAVARAM'},{'value':270,'label':'HINDUPUR'},{'value':271,'label':'KADIRI'},{'value':272,'label':'KALYANDURG'},{'value':273,'label':'MADAKASIRA'},{'value':275,'label':'PENUKONDA'},{'value':276,'label':'RAYADURG'},{'value':277,'label':'SINGANAMALA'},{'value':278,'label':'TADPATRI'},{'value':279,'label':'URAVAKONDA'},{'value':280,'label':'CHANDRAGIRI'},{'value':281,'label':'CHITTOOR'},{'value':282,'label':'KUPPAM'},{'value':283,'label':'NAGARI'},{'value':284,'label':'PALAMANER'},{'value':285,'label':'PILERU'},{'value':286,'label':'PUNGANUR'},{'value':288,'label':'SATYAVEDU'},{'value':289,'label':'SRIKALAHASTI'},{'value':290,'label':'THAMBALLAPALLE'},{'value':291,'label':'TIRUPATI'},{'value':294,'label':'MADANPALLE'},{'value':297,'label':'GUNTAKAL'},{'value':298,'label':'ANANTAPUR URBAN'},{'value':299,'label':'RAPTADU'},{'value':300,'label':'PUTTAPARTHI'},{'value':301,'label':'GANGADHARA NELLORE'},{'value':302,'label':'PUTHALAPATTU'},{'value':303,'label':'RAJANAGARAM'},{'value':304,'label':'RAJAHMUNDRY CITY'},{'value':305,'label':'RAJAHMUNDRY RURAL'},{'value':306,'label':'RAMPACHODAVARAM'},{'value':307,'label':'KAKINADA RURAL'},{'value':308,'label':'KAKINADA CITY'},{'value':309,'label':'MANDAPETA'},{'value':310,'label':'GANNAVARAM (EG)'},{'value':311,'label':'GUNTUR EAST'},{'value':312,'label':'GUNTUR WEST'},{'value':327,'label':'PEDANA'},{'value':328,'label':'MACHILIPATNAM'},{'value':329,'label':'PAMARRU'},{'value':330,'label':'PENAMALURU'},{'value':331,'label':'VIJAYAWADA CENTRAL'},{'value':332,'label':'SRISAILAM'},{'value':333,'label':'BANAGANAPALLE'},{'value':334,'label':'MANTRALAYAM'},{'value':340,'label':'NELLORE CITY'},{'value':341,'label':'NELLORE RURAL'},{'value':344,'label':'YERRAGONDAPALEM'},{'value':352,'label':'PALASA'},{'value':353,'label':'RAJAM'},{'value':354,'label':'VISAKHAPATNAM EAST'},{'value':355,'label':'VISAKHAPATNAM SOUTH'},{'value':356,'label':'VISAKHAPATNAM NORTH'},{'value':357,'label':'VISAKHAPATNAM WEST'},{'value':358,'label':'GAJUWAKA'},{'value':359,'label':'ARAKU VALLEY'},{'value':360,'label':'KURUPAM'},{'value':361,'label':'NELLIMARLA'},{'value':366,'label':'NIDADAVOLE'},{'value':368,'label':'BHIMILI'}],
                        SelfconstituencyValue:"",

                        SelfMandalMunValue:"",
                        volunteerMandalMunName:"",
                        mandalMunArr:[{'value':1,'label':'Mandal Name'}],

                        mahaShaktiCheckedCond:"",
                        annaDataCheckedCond:"",
                        yuvvaGalamCheckedCond:"",

                        yuvaGalamCheckBox:false,

                        annaDataCardId :"",
                        yuvaGalamCardId:"",
                        mahaShaktiCardId:"",

                        preferencesObj:[],
                        schemeCheckVerified:0,

                        validateVolunteerPhysicalCardId:"",
                        validateVolunteerName:"",
                        validateVolunteerGender:"",
                        validateVolunteerAge:"",
                        validateVolunteerOccupation:"",
                        validateVolunteerMobile:"",
                        validateVolunteerVoterCard:"",
                        validateVolunteerConstituencyName:"",
                        validateVolunteerPincode:"",
                        validateVolunteerMandalMunName:"",
                        validateVolunteerOTP:"",
                        validateVolunteerAddress:"",
                        validateInterests:"",

                        selfOptionScreenType:"slide_one",
                        selfOptionLoderSymbolSave:"hide",
                        selfOptionMessageSave:"",
                        yuvvaGalamCheckedUnemployedModal:false,
                        getCurrentLocationCoordinatesForDV:{},

                        smsSentMessage:"",
                        otpVerifiedMessageStatus:"",
                        otpLoadingSymbol:"hide",
                        getOTPLoadingSymbol:"hide",
                        OTPSentStatus:"",
                        resendOTPLoadingSymbol:"hide",
                        resendSmsSentMessage:"",
                        
                        minutes:1,
                        seconds:0,

                        audioSourceURL:"",
                        base64StrVoiceRecorded:"",
                        recordedMsg:"",

                        casteListArr:[{'value':1,'label':'OC'},{'value':2,'label':'BC'},{'value':3,'label':'SC'},{'value':4,'label':'ST'},{'value':5,'label':'Minority'},{'value':'','label':'Not Interested'}],
                        casteStr:"",
                        casteValue:{'value':'','label':'Not Interested'},

                        bcProtectionLawCheckBox:false,
                        annaDataCheckBox:false,
                        yuvaGagalamCheckBox:false,
                        mahaShaktiCheckBox:false,
                        smsForBG:"",

                        NOOfChildrens:0,
                        validateNOOfChildrens:"",
                        qrCodeUUID:"",

                        noOfWomen:0,
                        noOfUnEmployed:0,
                        noOfFarmers:0,
                        totalFamilyMembers:0,
                        validatenoOfWomen:"",
                        validatenoOfUnEmployed:"",
                        validatetotalFamilyMembers:"",

                        validateCaste:""
                    });

            /*const getUID = (length=5) => {
                var result           = '';
                var characters       = '0123456789';
                var charactersLength = characters.length;
                for ( var i = 0; i < length; i++ ) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            }
            const BGCardId = "6666120"+getUID();
            this.setState({ volunteerPhysicalCardId:BGCardId});*/
           // getFutureGuaranteeEnrollmentNumber()
      }


      
      resendOTPTimer = () => {
        this.setState({minutes:1});
        this.setState({seconds:0});

        this.OTPTimerFunction();
      };

    OTPTimerFunction = () => {
        const interval = setInterval(() => {
            if (this.state.seconds > 0) {
              this.setState({seconds:this.state.seconds - 1});
            }
      
            if (this.state.seconds === 0) {
              if (this.state.minutes === 0) {
                clearInterval(interval);
              } else {
                this.setState({seconds:59});
                this.setState({minutes:this.state.minutes - 1});

              }
            }
          }, 1000);
      
          return () => {
            clearInterval(interval);
          };
    }

    resendOTPNew = () => {
        this.setState({validateVolunteerMobile:"" });
        if(this.state.volunteerMobile == ""){
            this.setState({validateVolunteerMobile:"Please Enter Mobile No" });
            return;
        }
        var expr = /^(0|91)?[6-9][0-9]{9}$/;
        if(!expr.test(this.state.volunteerMobile)){
            this.setState({validateVolunteerMobile:"Please Enter Valid Mobile No" });
            return;
          }

        

        if(this.state.volunteerMobile.length < 10){
            this.setState({validateVolunteerMobile:"Please Enter Valid Mobile No" });
            return;
        }


        this.setState({resendOTPLoadingSymbol:"show"});
       
        const obj =  
            JSON.stringify({ 
            "chatId" :'943827154',
            "mobileNo" : this.state.volunteerMobile,
            
            }); 

            getAPICallData(obj,"sendOtpToMobileNumber")
            .then((res) => res.json())
            .then((data) => {
              this.setState({resendOTPLoadingSymbol:"hide"});
              if(data !=null && data.status == "Success"){
                this.resendOTPTimer();
              }
            });
    }
  
    getMobileNoOTP = () => {
        this.setState({validateVolunteerMobile:"" });
        var expr = /^(0|91)?[6-9][0-9]{9}$/;

        if(this.state.volunteerMobile == ""){
            this.setState({validateVolunteerMobile:"Please Enter Mobile No" });
            return;
        }

        if(!expr.test(this.state.volunteerMobile)){
            this.setState({validateVolunteerMobile:"Please Enter Valid Mobile No" });
            return;
          }

        if(this.state.volunteerMobile.length < 10){
            this.setState({validateVolunteerMobile:"Please Enter Valid Mobile No" });
            return;
        }


        this.setState({smsSentMessage:"",getOTPLoadingSymbol:"show",OTPSentStatus:""});
        
        const obj =  
            JSON.stringify({ 
            "chatId" :'943827154',
            "mobileNo" : this.state.volunteerMobile,
            
            }); 

            getAPICallData(obj,"sendOtpToMobileNumber")
            .then((res) => res.json())
            .then((data) => {
              this.setState({getOTPLoadingSymbol:"hide"});
              if(data !=null && data.status == "Success"){
                this.setState({smsSentMessage:"OTP Sent Your Mobile No",OTPSentStatus:data.status});
                this.OTPTimerFunction();
              }else{
                this.setState({smsSentMessage:"Some Thing Went Wrong,Please Try Again...",OTPSentStatus:"Fail"});
              }
            });
    }

    


    validateMobileOtp = (otp) => {
        this.setState({otpVerifiedMessageStatus:"",otpLoadingSymbol:"show"});
        const obj =  
            JSON.stringify({ 
            "chatId" :'943827154',
            "mobileNo" : this.state.volunteerMobile,
            "otp" : otp
            

            }); 

            getAPICallData(obj,"validateMobileOtp")
            .then((res) => res.json())
            .then((data) => {
               this.setState({otpLoadingSymbol:"hide"});
               if(data !=null && data.status == "Success"){
                this.setState({otpVerifiedMessageStatus:"Verified"});
              }else{
                this.setState({otpVerifiedMessageStatus:"NotVerified"});
              }
            });
    }


    addAudioElement = (blob) => {
        this.setState({ audioSourceURL:"",base64StrVoiceRecorded:"" });
        const url = URL.createObjectURL(blob);
        this.setState({ audioSourceURL:url });

        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend =  () => {
            var base64String = reader.result;
            setTimeout(() => { 
                this.setState({ base64StrVoiceRecorded: base64String});
            }, 500);
        }
    }

    saveUserVoiceForFutureGuarantee = () => {
        const obj =  
            JSON.stringify({ 
            "chatId" :'943827154',
            "voterCardNo" : this.state.volunteerVoterCard,
            "base64Str" : this.state.base64StrVoiceRecorded
            }); 

            getAPICallData(obj,"saveUserVoiceForFutureGuarantee")
            .then((res) => res.json())
            .then((data) => {
              if(data !=null && data.status == "Success"){
                this.setState({ recordedMsg: "Recorded SuccessFully"});
              }
            });
    }

    sendSMSForFutureGuaranteeProgram = (shortUrlCode,qrCodeUUID) => {
        const obj =  
        JSON.stringify({ 
        "chatId" :'943827154',
        "mobileNo" : this.state.volunteerMobile,
        "name" : this.state.volunteerName,
        "mgid" : this.state.volunteerPhysicalCardId.toString(),
        "url" : `www.tdpmanifesto.com/p/?i=${shortUrlCode}`
        }); 

        getAPICallData(obj,"sendConformationSMSForFGProgramEnrollment")
        .then((res) => res.json())
        .then((data) => {
          if(data !=null && data.status == "Success"){
            this.setState({ smsForBG: "SMS Sent SuccessFully"});
          }
        });
    }
      
    render() {
        console.log("autofocusMS",this.state.autofocusMS)
        return (
            <section>
               
                
                <Container>

                  {
                                this.state.selfOptionScreenType == "slide_one" ?
                                (
                                    <div className={`slide_one_css scroll_top`}>
                                        <Row>
                                            <Col>
                                                
                                                <Form>
                                                    
                                                        <label className="form-label f-12 fw-bold  mt-2">Interests <span className='color_red f-9'>{this.state.validateInterests}</span></label>
                                                        

                                                        <Row>
                                                     <Col sm={12}>
                                                        <Form className="check_box_size">
                                                            {
                                                                this.state.volunteerGender == "M" ||  this.state.volunteerGender == "m" || this.state.volunteerGender == "male" ?
                                                                (
                                                                    <Form.Check
                                                                        inline
                                                                        label={<img className="center-auto w_90_R" src={MS_logo} />}
                                                                        name="interestsId"
                                                                        type="checkbox"
                                                                        id="maha_shakti_id"
                                                                        onChange={(e)=>this.checkInterestValue(e,"1","MAHA_SHAKTI")}
                                                                        className="f-12 fw-bold color_black input_size_MS"
                                                                        checked={this.state.mahaShaktiCheckBox}
                                                                    />
                                                                )
                                                                :
                                                                (
                                                                    <Form.Check
                                                                        inline
                                                                        label={<img className="center-auto w_90_R" src={MS_logo} />}
                                                                        name="interestsId"
                                                                        type="checkbox"
                                                                        id="maha_shakti_id"
                                                                        onChange={(e)=>this.checkInterestValue(e,"1","MAHA_SHAKTI")}
                                                                        className="f-12 fw-bold color_black input_size_MS"
                                                                        checked={this.state.mahaShaktiCheckBox}
                                                                    />
                                                                )
                                                            }
                                                               
                                                                <Form.Check
                                                                    inline
                                                                    label={<img className="center-auto w_60_R" src={YG_logo} />}
                                                                    name="interestsId"
                                                                    type="checkbox"
                                                                    id="yuva_galam_id"
                                                                    onChange={(e)=>this.checkInterestValue(e,"2","YUVA_GALAM")}
                                                                    className="f-12 fw-bold color_black input_size"
                                                                    //checked={this.state.yuvvaGalamCheckedTF}
                                                                   // checked={this.state.yuvaGagalamCheckBox}
                                                                   checked={this.state.yuvaGagalamCheckBox}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label={<img className="center-auto w_60_R" src={AD_logo} />}
                                                                    name="interestsId"
                                                                    type="checkbox"
                                                                    id="ad_id"
                                                                    onChange={(e)=>this.checkInterestValue(e,"3","RYTHU_NESTAM")}
                                                                    className="f-12 fw-bold color_black input_size_AD"
                                                                    checked={this.state.annaDataCheckBox}
                                                                />
                                                        </Form>
                                                    </Col>
                                                     <Col sm={12}>
                                                        <Form className="check_box_size">
                                                            <Form.Check
                                                                inline
                                                                label={<img className="center-auto w_90_R" src={HW_logo} />}
                                                                name="interestsId"
                                                                type="checkbox"
                                                                id="house_water_id"
                                                                onChange={(e)=>this.checkInterestValue(e,"4","INTINTKI_WATER")}
                                                                className="f-12 fw-bold color_black input_size"
                                                                defaultChecked={true}
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={<img className="center-auto w_90_R" src={PTR_logo} />}
                                                                name="interestsId"
                                                                type="checkbox"
                                                                id="ptr_id"
                                                                onChange={(e)=>this.checkInterestValue(e,"5","POOR_TO_RICH")}
                                                                className="f-12 fw-bold color_black input_size"
                                                                defaultChecked={true}
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label={<img className="center-auto w_90_R" src={BC_logo} />}
                                                                name="interestsId"
                                                                type="checkbox"
                                                                id="bc_id"
                                                                onChange={(e)=>this.checkInterestValue(e,"6","BC_PROTECTION")}
                                                                className="f-12 fw-bold color_black input_size"
                                                                checked={this.state.bcProtectionLawCheckBox}
                                                            />
                                                            
                                                            </Form>
                                                        </Col>
                                                     </Row>

                                                     <Row>
                                                        <Col>
                                                            <Form.Group className="mt-2" controlId="formConstituencyNameId">
                                                                <Form.Label className='f-12 fw-bold'>Constituency/నియోజకవర్గం: <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-9'>{this.state.validateVolunteerConstituencyName}</span></Form.Label>
                                                                <SelectBox
                                                                    stateData={this.state.SelfconstituencyValue}
                                                                    handleChange={this.handleOnchangeSelectBoxNew}
                                                                    name="volunteerConstituencyName"
                                                                    options={this.state.ap_listArr}
                                                                    placeholderName={'Constituency'}
                                                                    dropdownIndicator={{ DropdownIndicator }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className='mt-2'>
                                                            <label className="form-label f-12 fw-bold">Booths<span className='color_red f-14 ms-1'>*</span><span className='f-12 color_red'>{this.state.validateSearchByBoothNo}</span>
                                                                {
                                                                    this.state.boothsLoadingSymbol == "show" ?
                                                                    (<Image src={loader} alt="loader" className='loader_cls ms-2 float-end'></Image>)
                                                                    :
                                                                    ("")
                                                                }
                                                                
                                                            </label>
                                                            <SelectBox
                                                                    stateData={this.state.SearchBoothValue}
                                                                    handleChange={this.handleOnchangeSelectBoxNew}
                                                                    name="volunteerSearchBoothName"
                                                                    options={this.state.searchOptionBoothListArr}
                                                                    placeholderName={'Booth'}
                                                                    dropdownIndicator={{ DropdownIndicator }}
                                                                />
                                                        </Col>
                                                     </Row>

                                                    <Form.Group className="mt-2" controlId="formPhyicalCardId">
                                                        <h6 className='f-12 fw-bold'>Bhavshyatuku Guarantee No<span className='color_red f-14 ms-1'>*</span> 
                                                            {
                                                                this.state.cardNoSymbol == "show" ?
                                                                (<Image src={loader} alt="loader" className='loader_cls ms-2 float-end'></Image>)
                                                                :
                                                                ("")
                                                            }
                                                        </h6>
                                                        <div className='flex-interests-align'>
                                                            <Form.Control type="text" name="volunteerPhysicalCardId" disabled  value={this.state.volunteerPhysicalCardId} className='form-control-sm' maxLength={12} placeholder="Enter Bhavshyatuku Guarantee No" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)} />
                                                            {/*<i class="fa-solid fa-qrcode float-right f-20 ms-2 mt_1 scanner_css" onClick={() => this.getQRScanCode("singleCard")}></i> */}
                                                        </div>
                                                        <h6 className='color_red f-9 mt-2 fw-bold'>{this.state.validateVolunteerPhysicalCardId} </h6> 
                                                        <h6 className='f-12 mt-2 color_red'>Note : Please Select Above Constituency To Get Bhavshyatuku Guarantee No.</h6>
                                                        
                                                    </Form.Group>


                                                   

                                                    <Row>
                                                        <Col>
                                                            <Form.Group className="" controlId="formNameId">
                                                                <Form.Label className='f-12 fw-bold'>Name/పేరు: <span className='color_red f-9'>{this.state.validateVolunteerName}</span></Form.Label>
                                                                <Form.Control type="text" name="volunteerName" value={this.state.volunteerName}  className='form-control-sm'  placeholder="Enter Name" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                            </Form.Group>
                                                        </Col>
                                                        
                                                    </Row>

                                                    <div className='scroll_two'>
                                                    <Row>
                                                    <Col>
                                                            <Form.Group className="mt-3" controlId="formGenderId">
                                                                <Form.Label className='f-12 fw-bold'>Gender/లింగం: <span className='color_red f-9'>{this.state.validateVolunteerGender}</span></Form.Label>
                                                                {
                                                                    this.state.volunteerGender == "F" ?
                                                                    (
                                                                        <select id="genderId" name="volunteerGender" className='form-select form-select-sm' onChange={(e) => this.handleOnchangeSelectBox(e)}>
                                                                            <option value="">Select Gender</option>
                                                                            <option value="F" selected>Female</option>
                                                                        </select>
                                                                    )
                                                                    :
                                                                    (
                                                                        <select id="genderId" name="volunteerGender" className='form-select form-select-sm' onChange={(e) => this.handleOnchangeSelectBox(e)}>
                                                                            <option value="">Select Gender</option>
                                                                            <option value="M">Male</option>
                                                                            <option value="F" >Female</option>
                                                                        </select>
                                                                    )
                                                                }
                                                            </Form.Group>
                                                        </Col>   
                                                        <Col>
                                                            <Form.Group  controlId="formAgeId" className='mt-3'>
                                                                <Form.Label className='f-12 fw-bold'>Age/వయస్సు: <span className='color_red f-9'>{this.state.validateVolunteerAge}</span></Form.Label>
                                                                <Form.Control name="volunteerAge" value={this.state.volunteerAge} className='form-control-sm' type="text" placeholder="Enter Age" maxLength={2} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                            </Form.Group>
                                                        </Col>
                                                        
                                                    </Row>
                                                    

                                                    <Row>
                                                        <Col>
                                                            <Form.Group className="mt-3" controlId="formOccupationId">
                                                                <Form.Label className='f-12 fw-bold'>Occupation/వృత్తి:<span className='color_red f-14 ms-1'>*</span>  <span className='color_red f-9'>{this.state.validateVolunteerOccupation}</span></Form.Label>
                                                                <SelectBox
                                                                    stateData={this.state.occupationValue}
                                                                    handleChange={this.handleOnchangeSelectBoxNew}
                                                                    name="volunteerOccupation"
                                                                    options={this.state.occupationListArr}
                                                                    placeholderName={'Occupation'}
                                                                    dropdownIndicator={{ DropdownIndicator }}
                                                                />
                                                            </Form.Group>   
                                                        </Col>
                                                        <Col>
                                                            <Form.Group className="mt-3" controlId="formOccupationId">
                                                                <Form.Label className='f-12 fw-bold'>Caste/కులం:<span className='color_red f-14 ms-1'>*</span>  <span className='color_red f-9'>{this.state.validateCaste}</span></Form.Label>
                                                                <SelectBox
                                                                    stateData={this.state.casteValue}
                                                                    handleChange={this.handleOnchangeSelectBoxNew}
                                                                    name="casteStr"
                                                                    options={this.state.casteListArr}
                                                                    placeholderName={'Select Caste'}
                                                                    dropdownIndicator={{ DropdownIndicator }}
                                                                />
                                                            </Form.Group>
                                                        </Col>

                                                    </Row>
                                                    </div>

                                                    <Row>
                                                        
                                                      
                                                        <Col>
                                                            <Form.Group className="mt-3" controlId="formVoterCardId">
                                                                <Form.Label className='f-12 fw-bold'>Voter Card/ఓటర్ కార్డ్: <span className='color_red f-9'>{this.state.validateVolunteerVoterCard}</span></Form.Label>
                                                                <Form.Control type="text" name="volunteerVoterCard" value={this.state.volunteerVoterCard} className='form-control-sm'  placeholder="Enter Voter Card ID" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col className='mt-3'>
                                                            <Form.Group  controlId="formtotalFamilyMembersId">
                                                                <Form.Label className='f-12 fw-bold'>Total Family Members/మొత్తం కుటుంబ సభ్యులు: <span className='color_red f-9'>{this.state.validatetotalFamilyMembers}</span></Form.Label>
                                                                <Form.Control name="totalFamilyMembers" className='form-control-sm' maxLength={2} type="text" value={this.state.totalFamilyMembers} placeholder="Enter Family Members" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                            </Form.Group>
                                                        </Col>
                                                        
                                                    </Row>

                                                    <Row>
                                                        <Col className='mt-3'>
                                                            <Form.Group  controlId="formNoOfChildrensId">
                                                                <Form.Label className='f-12 fw-bold'>No Of Childrens/ఎంతమంది పిల్లలు (18 సంవత్సరాలు లోపు):<span className='color_red f-9'>{this.state.validateNOOfChildrens}</span></Form.Label>
                                                                <Form.Control name="NOOfChildrens" className='form-control-sm' type="text" maxLength={1} value={this.state.NOOfChildrens} placeholder="Enter Childrens" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className='mt-2'>
                                                            <Form.Group  controlId="formnoOfWomenId">
                                                                <Form.Label className='f-12 fw-bold'>No Of Women/ఎంతమంది మహిళలు (18 సంవత్సరాలు పైన):<span className='color_red f-9'>{this.state.validatenoOfWomen}</span></Form.Label>
                                                                <Form.Control name="noOfWomen" className='form-control-sm' type="text" maxLength={2} value={this.state.noOfWomen} placeholder="Enter No Of Women" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                     <Row>
                                                        
                                                        <Col className='mt-2'>
                                                            <Form.Group  controlId="formnoOfUnEmployedId">
                                                                <Form.Label className='f-12 fw-bold'>No Of UnEmployed/ఎంతమంది నిరుద్యోగులు:<span className='color_red f-9'>{this.state.validatenoOfUnEmployed}</span></Form.Label>
                                                                <Form.Control name="noOfUnEmployed" className='form-control-sm' type="text" maxLength={2} value={this.state.noOfUnEmployed} placeholder="Enter No Of UnEmployed" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                   
                                                   {/*<Row>
                                                    <Col>
                                                        <Form.Label className='f-12 fw-bold mt-2'>Address <span className='color_red f-9'>{this.state.validateVolunteerAddress}</span></Form.Label>
                                                        <FloatingLabel
                                                                controlId="addressId"
                                                                label="Address"
                                                                className="f-12"
                                                                
                                                            >
                                                                <Form.Control as="textarea" placeholder="Enter Address" name="volunteerAddress" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                            </FloatingLabel>             
                                                            </Col>
                                                   </Row>*/}
                                                    

                                                    <Row>
                                                        <Col className='mt-2'>
                                                            <Form>
                                                                <Form.Group className="" controlId="formMobileId">
                                                                    <Form.Label className='f-12 fw-bold'>Mobile No/ఫోన్ నెంబర్:<span className='color_red f-9'>{this.state.validateVolunteerMobile}</span></Form.Label>
                                                                    <Form.Control type="text" name="volunteerMobile" className='form-control-sm' maxLength={10} value={this.state.volunteerMobile}  placeholder="Enter Mobile No" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                                         {
                                                                            this.state.getOTPLoadingSymbol == "show" ?
                                                                            (<Image src={loader} alt="loader" className='ms-2 get_otp_loading_symbol_cls'></Image>)
                                                                            :
                                                                            ("")
                                                                        }    
                                                                        {
                                                                            this.state.OTPSentStatus == "Fail" || this.state.OTPSentStatus == "" ?
                                                                            (
                                                                                <>
                                                                                <span className='f-12 color_red'>{this.state.smsSentMessage}</span>
                                                                                <Button variant="dark" className='f-12 float-right mt-2 btn-sm' onClick={() => this.getMobileNoOTP()}>GET OTP</Button> 
                                                                                </>
                                                                            )
                                                                            :
                                                                            ("")
                                                                        }

                                                                </Form.Group>  
                                                            </Form>
                                                            <Form>
                                                                <Form.Group className="mt-4" controlId="formOTPId">
                                                                    <Form.Label className='f-12 fw-bold'>OTP No<span className='color_red f-9'>{this.state.validateVolunteerOTP}</span></Form.Label>
                                                                    <Form.Control type="text" name="volunteerOTPNO" maxLength={6} className='form-control-sm' value={this.state.volunteerOTPNO}  placeholder="Enter OTP No" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                                    <Row>
                                                                        <Col>
                                                                            {
                                                                                this.state.OTPSentStatus == "Success"?
                                                                                (
                                                                                    <>
                                                                                        <h6 className='mt-2 f-12 color_green line_height_20'>{this.state.smsSentMessage} : <b >{this.state.volunteerMobile}</b></h6>
                                                                                        
                                                                                        {
                                                                                            this.state.otpVerifiedMessageStatus != "Verified" || this.state.otpVerifiedMessageStatus == "" ?
                                                                                            (
                                                                                                <div className="countdown-text">
                                                                                                    {this.state.seconds > 0 || this.state.minutes > 0 ? (
                                                                                                    <h6 className='mt-2 f-14'>
                                                                                                        Time Remaining: {this.state.minutes < 10 ? `0${this.state.minutes}` : this.state.minutes}:
                                                                                                        {this.state.seconds < 10 ? `0${this.state.seconds}` : this.state.seconds}
                                                                                                    </h6>
                                                                                                    ) : (
                                                                                                    <h6 className='mt-2 f-12'>Didn't recieve code?</h6>
                                                                                                    )}
                                                                                                    {
                                                                                                        this.state.resendOTPLoadingSymbol == "show" ?
                                                                                                        (<Image src={loader} alt="loader" className='ms-2 get_otp_loading_symbol_cls'></Image>)
                                                                                                        :
                                                                                                        ("")
                                                                                                    } 
                                                                                                    <Button variant="dark" className='f-12 float-right mt-2' 
                                                                                                    disabled={this.state.seconds > 0 || this.state.minutes > 0}
                                                                                                    style={{
                                                                                                        color: this.state.seconds > 0 || this.state.minutes > 0 ? "#DFE3E8" : "#fff",
                                                                                                    }} onClick={this.resendOTPNew}  >Resend OTP</Button>
                                                                                                    
                                                                                                </div>
                                                                                            )
                                                                                            :
                                                                                            ("")
                                                                                        }
                                                                                       
                                                                                        
                                                                                    </>
                                                                                )
                                                                                :
                                                                                ("")
                                                                            }
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        <Col>
                                                                            {
                                                                                    this.state.otpLoadingSymbol == "show" ?
                                                                                    (<Image src={loader} alt="loader" className='loader_cls_otp ms-2'></Image>)
                                                                                    :
                                                                                    (
                                                                                        this.state.otpVerifiedMessageStatus == "Verified" ?
                                                                                        (

                                                                                            <h6 class="color_green fw-bold f-14  text-center mt-3"><i class="fa-solid fa-check mr-2"> </i>OTP verified successfully</h6>
                                                                                            
                                                                                        )
                                                                                        :
                                                                                        (
                                                                                            this.state.otpVerifiedMessageStatus == "NotVerified" ?
                                                                                            (<h6 class="color_red fw-bold f-14 text-center mt-3"><i class="fa-solid fa-check mr-2"> </i>Not Verified,Please Enter Valid OTP</h6>)
                                                                                            :
                                                                                            ("")
                                                                                            
                                                                                        
                                                                                        )
                                                                                )
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Form.Group> 
                                                            </Form>    
                                                        </Col>
                                                    </Row>

                                                    {/*<Button variant="success" className='center-auto mt-4 f-14 fw-bold btn-sm mb-4' onClick={() => this.getSelfPhyicalCard()}>REGISTER</Button>*/}
                                                    <Row>
                                                        <Col>
                                                        {
                                                            this.state.selfOptionLoderSymbolSave === "show" ? (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image>) : ("")
                                                        }

                                                        <h6 className='f-14 fw-bold text-center mt-2'>{this.state.selfOptionMessageSave}</h6>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                                

                                            </Col>

                                            
                                        </Row>
                                       
                                    </div>
                                )
                                :
                                (
                                    ""
                                )
                            }

                
                    
                </Container>
                <YuvaGalamModal 
                        show={this.state.yuvvaGalamCheckedUnemployedModal}
                        onHide={() => this.setState({ yuvvaGalamCheckedUnemployedModal: false })}
                        stateData={this.state}
                        proccedForRegistrationYG={this.proccedForRegistrationYG}
                />
                <SuccessPage
                    show={this.state.successPageModal}
                    onHide={() => this.setState({ successPageModal: false })}
                    backToEnrollPage={this.backToEnrollPage}
                    stateData={this.state}
                 />
            
            </section>
        )
    }
  }
  
  export default withRouter(VoterSearchEnrollSave);
  